import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@/types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  selectedTenantId: string | null;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
  setSelectedTenant: (tenantId: string | null) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      selectedTenantId: null,
      
      setAuth: (user, token) => {
        set({
          user,
          token,
          isAuthenticated: true,
          selectedTenantId: user.role === 'admin' ? null : (user.tenantId || user.tenants?.[0]?.id || null),
        });
      },
      
      logout: () => {
        set({ user: null, token: null, isAuthenticated: false, selectedTenantId: null });
      },
      
      setSelectedTenant: (tenantId) => {
        set({ selectedTenantId: tenantId });
      },
    }),
    {
      name: 'one-platform-auth',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        selectedTenantId: state.selectedTenantId,
      }),
    }
  )
);
